export default __webpack_public_path__ + "img/wolf.63ac5342.svg";